import { render, staticRenderFns } from "./application-summary-loader.vue?vue&type=template&id=485869b0"
import script from "./application-summary-loader.vue?vue&type=script&lang=js"
export * from "./application-summary-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports